import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

const container = document.getElementById("root");
const app = <App />;

if (container.dataset.prerendered === "homepage") {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
